import React, { useEffect } from "react";
import { Navigate } from "react-router";

import { useAPI } from "../hooks/useAPI";
import { ENDPOINTS } from "../constants/endpoints.constant";
import { getCall } from "../constants/apicalls.constant";

import { User } from "../models/user";
import { useDispatch } from "react-redux";
import { logged } from "../store/slices/user.slice";
import Loader from "../components/Loader";
import { fetchMyGeoLocation } from "../store/slices/geolocation.slice";
import { AppDispatch } from "../store/store";
import { AddressType } from "../models/onboarding";
const ProtectedRoute = ({ element }: { element: React.JSX.Element }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { response, loading, error } = useAPI<User>(
    ENDPOINTS.me,
    true,
    [],
    getCall<User>(),
  );

  useEffect(() => {
    if (response?.status) {
      dispatch(
        logged({
          ...response?.data,
          ...response?.data?.organization,
          id: response?.data?.id,
          is_verified: response?.data?.is_verified,
          organizer_id: response?.data?.organization?.id,
          address: response?.data?.organization?.address
            ? response?.data?.organization?.address
            : ({} as AddressType),
          workspace: {
            id: response?.data?.workspace?.id,
            name: response?.data?.workspace?.name,
            feature_image: response?.data?.workspace?.feature_image,
            role: response?.data?.workspace?.role,
          },
          user_workspaces: response?.data?.user_workspaces,
          organization: response?.data?.organization,
          legal_name: response?.data?.organization?.legal_name,
          gst: response?.data?.organization?.gst_details
            ? response?.data?.organization?.gst_details
            : [],
        }),
      );
      if (
        !localStorage.getItem("currency") &&
        !localStorage.getItem("timezone")
      )
        dispatch(fetchMyGeoLocation());
    }
  }, [response]);
  if (loading) return <Loader />;
  if (error) return <div>something went wrong ...</div>;
  if (response?.status && response?.data?.status === "draft") {
    return <Navigate to="/login" />;
  }
  return response?.status ? element : <Navigate to="/login" />;
};

export default ProtectedRoute;
